/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Polygon, Polyline } from 'react-native-svg';

import { IconProps } from '../lib';

function GraduationCap(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M36,110.93333v54.5208a7.95694,7.95694,0,0,0,1.58951,4.78692C44.32618,179.20536,72.7471,212,128,212s83.67382-32.79464,90.41049-41.75895A7.95694,7.95694,0,0,0,220,165.45413v-54.5208L128,160Z"
        opacity={0.2}
      />
      <Polygon
        points="8 96 128 32 248 96 128 160 8 96"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="188 240 188 128 128 96"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M220,110.93333v54.5208a7.95694,7.95694,0,0,1-1.58951,4.78692C211.67382,179.20536,183.2529,212,128,212s-83.67382-32.79464-90.41049-41.75895A7.95694,7.95694,0,0,1,36,165.45413v-54.5208"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default GraduationCap;
